import { Repository, EntityRepository } from 'typeorm';
import { PoCreation } from '../po-creation.entity';


@EntityRepository(PoCreation)
export class PoRepository extends Repository<PoCreation>{

    /**
     *
     * @param PurchaseOrderId the po id
     */
    async getPoData(poId: number): Promise<any> {
        const poEntity = this.createQueryBuilder("PoCreation")
        .leftJoinAndSelect('PoCreation.poCreationItemsInfo', 'poCreationItemsInfo')  
        .where('PoCreation.purchase_order_id='+poId+' and poCreationItemsInfo.item_quantity>poCreationItemsInfo.received_quantity and poCreationItemsInfo.status=1')
        .getOne();
            // console.log(poEntity)
        return poEntity ;
    }


    async getPoDataForPoDetailView(poId: number): Promise<any> {
        const poEntity = this.createQueryBuilder("PoCreation")
        .leftJoinAndSelect('PoCreation.poCreationItemsInfo', 'poCreationItemsInfo')
        .where('PoCreation.purchase_order_id='+poId)
        .getOne();
            // console.log(poEntity)
        return poEntity ;
    }
    

    
}
